module.exports = __webpack_public_path__ + "96556fdf32d5f39ae01a023f2937e2ae.svg";